import React, { FC, memo } from 'react';

import { useClassnames } from 'hook/use-classnames';
import style from './input.pcss';

interface IProps {
    value: string;
    placeholder?: string;
    onChange(e: React.ChangeEvent<HTMLInputElement>): void;
}

const Input: FC<IProps> = ({value, onChange, placeholder = 'Поиск по названию...'}) => {
    const cn = useClassnames(style);

    return (
        <div className={cn('input')}>
            <input
                type="text"
                placeholder={placeholder}
                value={value}
                onChange={onChange}
                className={cn('input-field')}
            />
        </div>
    );
};

export default memo(Input);
